export default "__VITE_ASSET__CqRStkmq__"